import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Modal from '../../common/components/Modal';
import app from '../app';
import Button from '../../common/components/Button';
import Form from '../../common/components/Form';
import Stream from '../../common/utils/Stream';
import Icon from '../../common/components/Icon';
export default class ExtensionBisect extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "result", Stream(null));
    _defineProperty(this, "bisecting", Stream(app.data.bisecting || false));
  }
  get dismissibleOptions() {
    return {
      viaCloseButton: !this.bisecting(),
      viaEscKey: !this.bisecting(),
      viaBackdropClick: !this.bisecting()
    };
  }
  oninit(vnode) {
    super.oninit(vnode);
    if (m.route.param('modal') !== 'extension-bisect') {
      window.history.replaceState({}, '', window.location.pathname + '#' + app.route('advanced', {
        modal: 'extension-bisect'
      }));
    }
  }
  className() {
    return 'ExtensionBisectModal Modal--small';
  }
  title() {
    return app.translator.trans('core.admin.advanced.maintenance.bisect_modal.title');
  }
  content() {
    const result = this.result();
    if (result && result.extension) {
      const extension = app.data.extensions[result.extension];
      return m("div", {
        className: "Modal-body"
      }, m(Form, {
        className: "Form--centered"
      }, m("p", {
        className: "helpText"
      }, app.translator.trans('core.admin.advanced.maintenance.bisect_modal.result_description')), m("div", {
        className: "ExtensionBisectModal-extension"
      }, m("div", {
        className: "ExtensionBisectModal-extension-icon ExtensionIcon",
        style: extension.icon
      }, extension.icon ? m(Icon, {
        name: extension.icon.name
      }) : ''), m("div", {
        className: "ExtensionBisectModal-extension-info"
      }, m("div", {
        className: "ExtensionBisectModal-extension-name"
      }, extension.extra['flarum-extension'].title), m("div", {
        className: "ExtensionBisectModal-extension-version"
      }, m("span", {
        className: "ExtensionBisectModal-extension-version"
      }, extension.version)))), m(Button, {
        className: "Button Button--primary",
        onclick: () => this.hide(extension.id)
      }, app.translator.trans('core.admin.advanced.maintenance.bisect_modal.end_button'))));
    }
    return m("div", {
      className: "Modal-body"
    }, m(Form, {
      className: "Form--centered"
    }, m("p", {
      className: "helpText"
    }, app.translator.trans('core.admin.advanced.maintenance.bisect_modal.description')), m("p", {
      className: "helpText"
    }, app.translator.trans('core.admin.advanced.maintenance.bisect_modal.' + (this.bisecting() ? 'steps_left' : 'total_steps'), {
      steps: this.stepsLeft()
    })), this.bisecting() ? m("div", {
      className: "Form-group"
    }, m("label", null, app.translator.trans('core.admin.advanced.maintenance.bisect_modal.issue_question')), m("p", {
      className: "helpText"
    }, app.translator.trans('core.admin.advanced.maintenance.bisect_modal.issue_question_help'))) : null, this.bisecting() ? m('[', null, m("div", {
      className: "ButtonGroup ButtonGroup--block"
    }, m(Button, {
      className: "Button Button--danger",
      onclick: () => this.submit(true),
      loading: this.loading
    }, app.translator.trans('core.admin.advanced.maintenance.bisect_modal.yes_button')), m(Button, {
      className: "Button Button--success",
      onclick: () => this.submit(false),
      loading: this.loading
    }, app.translator.trans('core.admin.advanced.maintenance.bisect_modal.no_button'))), m(Button, {
      className: "Button Button--primary Button--block",
      onclick: () => this.submit(null, true),
      loading: this.loading
    }, app.translator.trans('core.admin.advanced.maintenance.bisect_modal.stop_button'))) : m(Button, {
      className: "Button Button--primary Button--block",
      onclick: () => this.submit(true),
      loading: this.loading
    }, app.translator.trans('core.admin.advanced.maintenance.bisect_modal.start_button'))));
  }
  stepsLeft() {
    if (this.result()) {
      return this.result().stepsLeft;
    }
    let steps;
    if (this.bisecting()) {
      const {
        low,
        high
      } = JSON.parse(app.data.settings.extension_bisect_state);
      steps = Math.ceil(Math.log2(high - low)) + 1;
    } else {
      steps = Math.ceil(Math.log2(JSON.parse(app.data.settings.extensions_enabled).length)) + 1;
    }
    return steps;
  }
  submit(issue, end) {
    if (end === void 0) {
      end = false;
    }
    this.loading = true;
    m.redraw();
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/extension-bisect',
      body: {
        issue,
        end
      }
    }).then(response => {
      this.loading = false;
      this.bisecting(!end);
      this.result(response);
      m.redraw();
      if (end) {
        this.hide();
      }
    });
  }
  hide(extension) {
    this.attrs.animateHide(() => {
      if (extension) {
        m.route.set(app.route('extension', {
          id: extension
        }));
      } else {
        m.route.set(app.route('advanced'));
      }
      window.location.reload();
    });
  }
}
_defineProperty(ExtensionBisect, "isDismissibleViaCloseButton", true);
_defineProperty(ExtensionBisect, "isDismissibleViaEscKey", false);
_defineProperty(ExtensionBisect, "isDismissibleViaBackdropClick", false);
flarum.reg.add('core', 'admin/components/ExtensionBisect', ExtensionBisect);